import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { IApplicationReport } from '@entities/application/IApplicationReport';

export const fetchData = async ({
  title,
  data,
}: {
  title: string;
  data: string;
}): Promise<void> => {
  await api.post<IApplicationReport>(`${PANEl_BASE_URL}/hashrates/reports/`, {
    filename: title,
    file_data: data,
  });
};

export const useUploadReport = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
